const image = {
    logo: require('~/assets/images/logo.svg').default,
    noImage: require('~/assets/images/no-image.png'),
    // require () => module object { default : link svg}
    // import => link svg
    // => require().default = import
};
export default image;
